// src/components/AttendanceTable.js
import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Checkbox,
} from "@mui/material";
import axios from "axios";
import { useQuery } from "react-query";
import { url, localUrl } from "./../../BaseUrl";
const rows = [
  { id: 1, name: "John Doe", status: "Present" },
  { id: 2, name: "Jane Smith", status: "Absent" },
  // Add more rows as needed
];

const AttendanceTable = ({tableData}) => {
  const { isLoading, error, data } = useQuery("getAttendance", async () => {
    const token = sessionStorage.getItem("token");

    const response = await axios.get(
      `${url}/api/auth/getAttendance`, // Ensure the correct endpoint
      {
        headers: {
          Authorization: `Bearer ${token}`, // Send token in the Authorization header
          "Content-Type": "application/json",
        },
      }
    );

    return response.data; // Return the fetched data
  });
 
  return (
    <TableContainer component={Paper}>
      <Table aria-label="attendance table">
        <TableHead>
          <TableRow>
            <TableCell>ID</TableCell>
            <TableCell>Name</TableCell>
            <TableCell>Status</TableCell>
            <TableCell align="center">Mark</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
         {tableData?.attendance.map((attendanceEntry) =>
            attendanceEntry?.records?.map((row) => (
              <TableRow key={row?._id}>
                <TableCell>{row?.studentId}</TableCell>
                <TableCell>{row?.name}</TableCell>
                <TableCell>{row?.status}</TableCell>
                <TableCell align="center">
                  <Checkbox checked={row?.status === 'Present'} />
                </TableCell>
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default AttendanceTable;
